import * as React from 'react';
import axios from 'axios';
import { useForm, isNotEmpty } from '@mantine/form';
import { Box, TextInput, Group, Button, PasswordInput, Title, createStyles, Text } from '@mantine/core';
import useStore from "../../store";
import type { IResponse } from "../../types/api";
import { IconAt, IconKey, IconChevronRight } from '@tabler/icons-react';
import ForgotPassword from "./ForgotPassword";
import logo from '../../assets/images/logo.png';

import styles from './login.module.scss';

interface ILoginResponse {
    email: string;
    expiresIn: number;
    phoneNumber: string;
    roleName: string;
    token: string;
    name: string;
    profilePicture: string;
}

const Login = () => {

    const { classes } = useStyles();
    const setLoginInfo = useStore(store => store.setLoginInfo);

    const [ forgotPassword, setForgotPassword ] = React.useState(false);

    const form = useForm({
        initialValues: {
            email: '',
            password: '',
        },
        clearInputErrorOnChange: true,
        validate: {
            email: isNotEmpty('Нэвтрэх нэр оруулна уу'),
            password: isNotEmpty('Нууц үг оруулна уу'),
        },
    });

    const handleSubmit = async (values: typeof form.values) => {
        const { data } = await axios.post<IResponse<ILoginResponse>>('/auth/login', values);
        setLoginInfo(data.result);
    }

    return (
        <div className={styles.container}>
            <div
                className={classes.sideBar}
            >
                <img
                    src={logo}
                    alt={'Duul. KARAOKE'}
                />
            </div>
            {/*<div*/}
            {/*    style={{*/}
            {/*        flex: 3,*/}
            {/*        backgroundColor: '#7950f2'*/}
            {/*    }}*/}
            {/*    className={styles.image}*/}
            {/*/>*/}

            <div className={styles.card}>
                <Box sx={{ maxWidth: 500 }} mx="auto">
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <div className={classes.header}>
                            <Text
                                fw={800}
                                fz={40}
                                variant='gradient'
                                gradient={{
                                    from: '#61009e',
                                    to: '#4653b9',
                                    deg: 90
                                }}
                            >
                                Duul. Karaoke
                            </Text>

                            <div className={classes.divider}/>
                            <div className={classes.headerText}>
                                OFFICE
                            </div>
                        </div>
                        <Title order={1}>
                            Тавтай морил!
                        </Title>
                        <Text c='dimmed' fz='md' fw={400} mb={'2rem'}>
                            Бүртгэлийн мэдээллээ ашиглан нэвтэрч орно уу
                        </Text>
                        <TextInput
                            label='Нэвтрэх нэр'
                            autoComplete={'off'}
                            placeholder='email@example.com'
                            style={{ marginBottom: '1rem' }}
                            labelProps={{
                                className: classes.label
                            }}
                            mb={'sm'}
                            icon={<IconAt size={18}/>}
                            {...form.getInputProps('email')}
                        />

                        <PasswordInput
                            icon={<IconKey size={18}/>}
                            label={'Нууц үг'}
                            placeholder="******"
                            labelProps={{
                                className: classes.label
                            }}
                            {...form.getInputProps('password')}
                        />

                        <div className={classes.buttons}>
                            <Button
                                variant={'subtle'}
                                compact
                                className={styles.forgotPasswordButton}
                                onClick={() => setForgotPassword(true)}
                            >
                                Нууц үгээ мартсан уу?
                            </Button>
                            <Button
                                type="submit"
                                variant='outline'
                                radius='xl'
                                size='md'
                                rightIcon={<IconChevronRight size={18}/>}
                            >
                                Нэвтрэх
                            </Button>
                        </div>
                    </form>
                </Box>
            </div>
            {
                forgotPassword && (
                    <ForgotPassword
                        onClose={() => setForgotPassword(false)}
                    />
                )
            }
        </div>
    );
};

const useStyles = createStyles((theme) => {
   return {
       form: {
           width: 380,
       },
       header: {
           display: 'flex',
           gap: '1rem',
           alignItems: 'center',
           marginBottom: '6rem'
       },
       headerText: {
           fontWeight: 500,
           fontSize: 20
       },
       divider: {
           borderRight: '1px solid black',
           alignSelf: 'stretch',
           margin: '.5rem 0'
       },
       version: {
           borderRadius: '15px',
           background: '#F1F3F5',
           padding: '.3rem .8rem',
           fontSize: 12,
           color: '#8E8E8F',
           fontWeight: 600
       },
       label: {
           fontWeight: 600,
           fontSize: 16
       },
       logo: {
           padding: '1rem',
           width: 400
       },
       sideBar: {
           background: theme.fn.gradient(),
           flex: 3,
           display: 'grid',
           placeItems: 'center'
       },
       buttons: {
           display: 'flex',
           justifyContent: 'space-between',
           alignItems: 'center',
           marginTop: theme.spacing.xl
       }
   }
});

export default Login;
